import React from "react";
import { translate } from "react-i18next";
import { Button, Modal } from "semantic-ui-react";
import DeleteAxios from "../axiosComponent/delete";

function BranchDeleteModal({branchId,ConfirmDeleteRow,deleteOpen,CloseModal,t}) {
  return (
    <Modal onClose={CloseModal} open={deleteOpen} size="mini">
      <Modal.Header>{t("notification")}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>{t("message")}</p>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="green"
          size="mini"
          type="button"
          onClick={CloseModal}
        >
          {t("cancel")}
        </Button>
        <Button type="button" size="mini" color="blue" onClick={ConfirmDeleteRow}>
          {t("ok")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default translate('user_table')(BranchDeleteModal);
